<template>
  <div>
    <v-system-bar dark color="#000" height="40" class="hidden-sm-and-down">
      <v-layout wrap justify-center>
        <v-flex xs9 xl10 align-self-center>
          <!-- <marquee scrollamount="0" behavior="alternate"> -->
          <v-layout wrap justify-center>
            <v-flex xs12 align-self-center text-center>
              <span>
                <img
                  height="19px"
                  width="23px"
                  class="object-fit:contain"
                  :src="require('./../../assets/Images/hotsale.svg')"
                />
                Use Coupon Code for 10% Discount
                <span style="border: 1px dashed white">&nbsp;SAVE10 </span>
                &nbsp;Offer Ends in 2:30:00
              </span>
            </v-flex>
          </v-layout>
          <!-- </marquee> -->
        </v-flex>
      </v-layout>
    </v-system-bar>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      marquee: null,
    };
  },
  beforeMount() {
    // this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/static/getbyname",
        params: {
          Name: "Marquee",
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.marquee = response.data.data.Value;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>